/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_d4563441 .ms-Suggestions-itemButton{padding:0;border:none}.callout_d4563441 .ms-Suggestions{min-width:300px}:export{callout:callout_d4563441}"}]);
export const callout = "callout_d4563441";